import {SET_SNACK} from './../constants';
import {SET_META_DATA} from './../constants';
import {SET_SUPER_USER} from './../constants';
import {SET_GENERAL} from './../constants';
import {SET_SW_DATA} from './../constants';
export const setSnackDetails = (value) => ({
	type: SET_SNACK,
	payload: value,
}); 
export const setMetaData = (value) => ({
	type: SET_META_DATA,
	payload: value,
});
export const setSuperUser = (value) => ({
	type: SET_SUPER_USER,
	payload: value,
});

export const setGeneral = (value) => ({
	type: SET_GENERAL,
	payload: value,
});

export const setSweetAlert = (value) => ({
	type: SET_SW_DATA,
	payload: value,
});